import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from "../../../../../../../../core/service/v2/dataservice/abstractDataServiceV2";
import {TreatmentJourneyDefinitionModel} from "../../../api/entity/treatmentJourneyDefinition.model";
import {TreatmentJourneyDefinitionConverter} from "../../../api/entity/treatmentJourneyDefinition.converter";
import {CustomizeHttpUrlGenerator} from "../../../../../../../../../store/core/url/customizeHttpUrlGenerator";

@Injectable({
    providedIn: 'root'
})
export class TreatmentJourneyDefinitionDataService extends AbstractDataServiceV2<TreatmentJourneyDefinitionModel, TreatmentJourneyDefinitionConverter> {
    constructor(http: HttpClient,
                httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger,
                config: DefaultDataServiceConfig,
                converter: TreatmentJourneyDefinitionConverter) {
        super('TreatmentJourneyDefinition', http, httpUrlGenerator, logger, config, converter);
    }
}
